import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const DILIGENTSIA = 'https://diligentsia.co.uk';

const ResourcesCtaSection = () => (
    <section className="lp-res-cta" style={{ margin: '0px' }}>
        <div aria-hidden="true" className="lp-res-cta-glow lp-res-cta-glow--l" />
        <div aria-hidden="true" className="lp-res-cta-glow lp-res-cta-glow--r" />
        <div className="lp-res-cta-inner">
            <h2 data-lp-reveal>Ready to build your Diligence Pack?</h2>
            <p data-lp-reveal data-lp-delay="60">Start free. No credit card required.</p>
            <div className="lp-cta-row" style={{ justifyContent: 'center' }} data-lp-reveal data-lp-delay="120">
                <a className="lp-btn lp-btn--pe-pink" href={DILIGENTSIA} target="_blank" rel="noopener noreferrer">Get started free</a>
                <a className="lp-btn lp-btn--dark-outline" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
            </div>
        </div>
    </section>
);

export default ResourcesCtaSection;
